import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import styles from './imageViewPopUp.module.scss';

export const ImageViewPopUp = observer(function () {
  const {
    popUpStore: { popUpImage, title },
  } = useStore();

  return (
    <>
      <p className={styles.title}>{title}</p>
      <div className={styles.imageBox}>
        <img src={popUpImage} alt='popup-image' className={styles.image} />
      </div>
    </>
  );
});
